"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ManagerPageUsers = void 0;
const User_1 = require("benjibooks-shared/models/User");
const firestore_1 = require("firebase/firestore");
const react_1 = __importStar(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const Container_1 = __importDefault(require("react-bootstrap/Container"));
const authContext_1 = require("../../context/authContext");
const configContext_1 = require("../../context/configContext");
const environment_1 = require("../../environment");
const useFirestore_1 = require("../../utils/useFirestore");
const IconAddCircleOutline_1 = require("../icons/IconAddCircleOutline");
const IconHelpOutline_1 = require("../icons/IconHelpOutline");
const ManagerInviteUserModal_1 = require("../manager-invite-user-modal/ManagerInviteUserModal");
const ManagerUsersTable_1 = require("../manager-tables/ManagerUsersTable");
const Spinner_1 = require("../spinner/Spinner");
const ManagerPageUsers = (props) => {
    const [modal, setModal] = (0, react_1.useState)();
    function showModal(newModal) {
        setModal(newModal);
    }
    function hideModal() {
        setModal(undefined);
    }
    const [users, setUsers] = (0, react_1.useState)([]);
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const [auth, authInfo] = (0, authContext_1.useAuth)();
    const config = (0, configContext_1.useConfig)();
    const firestore = (0, useFirestore_1.useFirestore)();
    /** Load users. */
    (0, react_1.useEffect)(() => {
        setIsLoading(true);
        const unsubscribeQuery = (0, firestore_1.onSnapshot)((0, firestore_1.query)((0, firestore_1.collection)(firestore, "users"), (0, firestore_1.where)("memberOf", "array-contains", config.tenantId)), (querySnapshot) => {
            const users = querySnapshot.docs.map((user) => User_1.User.fromJSON(user.id, user.data()));
            setUsers(users);
            setIsLoading(false);
        }, (err) => {
            console.error(err);
        });
        return () => unsubscribeQuery();
    }, []);
    /**
     * Handles the invitation of a user as manager or admin of this tenant.
     */
    async function handleInviteUser(email, name, isAdmin) {
        setIsLoading(true);
        // Save the user via Firebase functions.
        const response = await fetch(`${(0, environment_1.getEnv)().baseUrl}/api/invites`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: await authInfo.getAuthHeader(),
            },
            body: JSON.stringify({ email, name, isAdmin, tenantId: config.tenantId }),
        });
        setIsLoading(false);
    }
    async function handleUserChange(newUser) {
        setIsLoading(true);
        // Update the user via Firebase functions.
        const response = await fetch(`${(0, environment_1.getEnv)().baseUrl}/api/users/${newUser.id}`, {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                Authorization: await authInfo.getAuthHeader(),
            },
            body: JSON.stringify(newUser),
        });
        setIsLoading(false);
    }
    let content;
    if (isLoading) {
        content = react_1.default.createElement(Spinner_1.Spinner, { className: "my-3 mx-auto" });
    }
    else if (users) {
        content = (react_1.default.createElement(ManagerUsersTable_1.ManagerUsersTable, { users: users, onUserMembershipsChange: handleUserChange }));
    }
    else {
        content = "Fehler beim Laden der User. Bitte Support kontaktieren.";
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Container_1.default, { fluid: true, className: "manager-page-users main-content d-flex flex-column" },
            react_1.default.createElement("div", { className: "d-flex align-items-center justify-content-between mt-4 mb-4" },
                react_1.default.createElement("h1", { className: "text-nowrap mb-0" },
                    "Benutzer",
                    react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { placement: "right", overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: "title-tooltip" }, "Verwalten von Benutzern.") },
                        react_1.default.createElement("span", { className: "text-secondary pl-1", style: { fontSize: "20px" } },
                            react_1.default.createElement(IconHelpOutline_1.IconHelpOutline, null)))),
                react_1.default.createElement(react_bootstrap_1.Button, { className: "no-print", variant: "primary", onClick: () => showModal(react_1.default.createElement(ManagerInviteUserModal_1.ManagerInviteUserModal, { onClose: hideModal, onOk: (email, name, isAdmin) => {
                            handleInviteUser(email, name, isAdmin);
                            hideModal();
                        } })) },
                    react_1.default.createElement(IconAddCircleOutline_1.IconAddCircleOutline, null),
                    " Benutzer hinzuf\u00FCgen")),
            content),
        modal));
};
exports.ManagerPageUsers = ManagerPageUsers;
